module.exports = __webpack_public_path__ + "static/media/icon-wechat-white-selected.81bc0cda.svg";